module.exports = "<a href={%- ruleHref %}> {%- value %} </a>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/returnsRules/html/ruleLink.html
// module id = 1413
// module chunks = 1